import {useAuthAxios} from 'hooks/api/useAuthAxios'

export const useUpdateProcedureStatus = () => {
  const authAxios = useAuthAxios()

  return async (procedureStatusId: string, dateOn: string) => {
    return authAxios.put(`/api/procedure_statuses/${procedureStatusId}`, {date_on: dateOn})
  }
}
